import React, { useEffect, useRef, useState } from "react";
import FormStrip from "../../components/FormStrip";
import { useTranslation } from "react-i18next";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader, Toast } from "@egovernments/digit-ui-react-components";
import SubStep1 from "./Step1/SubStep1";
import getMapSubmissionData from "../map-submission/getMapSubmissionData";
import SubStep2 from "./Step1/SubStep2";
import SubStep3 from "./Step1/SubStep3";
import Step6 from "../map-submission/Step6";
import ReactToPrint from "react-to-print";
import SubStep4 from "./Step1/SubStep4";
import Step2 from "./Step2";
import Step3 from "./Step3";
import SearchSummary from "../map-submission/Summary/SearchSummary";
import { Card } from "@mui/material";
import ButtonWrapper from "../../components/Button";
import { useHistory } from "react-router-dom";
import Step4 from "./Step4";
import getSelfApprovalMapSubmissionData from "./getSelfApprovalMapSubmission";

const SelfApprovalPortal = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("SA_CURRENT_SUBTAB") || 0);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("SA_CURRENT_TAB") || 0);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [summaryShow, setSummaryshow] = useState(Digit?.SessionStorage.get("SUMMARYSA_TAB") || false);
  const history = useHistory();
  // const { applicationData, isAppDataLoading } = getMapSubmissionData(t, id);
  const { applicationData, isAppDataLoading } = getSelfApprovalMapSubmissionData(t, id);

  const { info: userInfo } = Digit.UserService.getUser();
  const userType = userInfo?.info?.type;
  const isEmployee = userType === "EMPLOYEE";
  const Modal = useModal();
  const componentRef = useRef();
  const subTabLabels = [
    { label: "Application Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
  ];
  const closeToast = () => {
    setShowToast(null);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_SELF_APPROVAL", applicationData);

  const validationRules = [
    {
      path: "natureOfConstruction",
      errorMessage: "Please fill all the mandatory details in Application Information tab.",
      condition: (value) => !value,
    },
    {
      path: "descriptionOfLand.landArea",
      errorMessage: "Please fill all the mandatory details in plot details tab.",
      condition: (value) => !value,
    },
    {
      path: "landInfo.owners.[0].name",
      errorMessage: "Please fill all the mandatory details in Applicant Information tab.",
      condition: (value) => !value,
    },
    {
      path: "descriptionOfLand.latitude",
      errorMessage: "Please fill all the mandatory detials in Geo Location tab",
      condition: (value) => !value,
    },
    {
      path: "descriptionOfLand.latitude",
      errorMessage: "Please fill all the mandatory detials in Geo Location tab",
      condition: (value) => !value,
    },
  ];

  const useFormSubmitValidation = (validationRules, payload) => {
    console.log("loggingPayload", payload, validationRules);

    const validate = () => {
      let formIsValid = true;

      // Iterate through validation rules and check conditions
      validationRules.forEach((rule) => {
        const { path, errorMessage, condition = (value) => !value } = rule;
        const value = get(payload, path);
        console.log("valueFromValidation", value, path);

        if (condition(value)) {
          Modal("Validation Error", errorMessage, "error");
          formIsValid = false;
          return; // You can't break out of forEach directly, so return early from the function
        }
      });
      return formIsValid;
    };
    const isValid = validate();
    return isValid;
  };
  const {
    data: { LandUseMasterData: { Authorities: schemeTypeData } = {} } = {},
    isLoading: schemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: { PrimaryUseMasterData: { ProposedActivity: nonSchemeTypeData } = {} } = {},
    isLoading: nonSchemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      console.log(data, "updatedDatahere");

      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);

  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      if (data?.additionalDetails) {
        delete data.additionalDetails;
      }
      if (activeTab === 0 && selectedSubTab === 0 && !id && !data?.applicationNo) {
        delete data.applicationNo;
        if (!data.workflow) {
          data.workflow = {};
        }
        data.riskType = "MEDIUM";
        data.workflow.action = "INITIATE";
        Digit.OBPSService.create({ BPA: data }, tenantId)
          .then((res) => {
            if (res?.BPA?.length > 0) {
              onSelect("", { ...data, ...res.BPA[0] }, true);
              setShowToast({
                error: false,
                message: `Application Created Successfully!`,
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { BPA: data },
            {
              onSuccess: (res) => {
                onSelect("", res?.BPA?.[0]);
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setSelectedSubTab(nextSubTab);
                Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  const { data: { BPA: { StandardBuildingDesigns: standardDesigns } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    ["StandardBuildingDesigns"]
  );
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      const isSelfCert = [
        "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm",
        "Self Certification of residential Plot Area upto 300 SqM on approved layouts",
      ]?.includes(params?.planOn);
      console.log("isSelfCertFromTabchange", isSelfCert, params?.planOn);
      try {
        if (nextTabNo === 5 && params?.status !== "REVERT_TO_APPLICANT") {
          data.workflow = { action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT", assignes: null };
        } else if (nextTabNo === 5 && params?.status === "REVERT_TO_APPLICANT") {
          data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
        } else {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
        }
        await updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: (res) => {
              onSelect("", { ...data, ...res?.BPA?.[0] });
              if (nextTabNo === 5) {
                // const isValid = useFormSubmitValidation(validationRules, data);
                // if(!isValid){
                //   return;
                // }
                if (params?.status === "REVERT_TO_APPLICANT") {
                  Modal(
                    "Application Submited",
                    `Your Application ${params?.applicationNo} has been sent to department for further approval`,
                    "success"
                  );
                  setActiveTab(nextTabNo);
                  Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
                } else {
                  if (isSelfCert) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else if (params?.taxHeadEstimates?.length > 1) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[1]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  }
                  clearParams();
                  Digit.SessionStorage.del("FORM_SELF_APPROVAL");
                  Digit?.SessionStorage.del("EDCR_CREATE");
                  Digit?.SessionStorage.del("FASTPAS_ID");
                  Digit?.SessionStorage.del("SUMMARYSA_TAB");
                  setTimeout(() => {
                    resetFormMTDocs();
                  }, 0);
                  Digit.SessionStorage.del("SA_CURRENT_TAB");
                  Digit.SessionStorage.del("SA_CURRENT_SUBTAB");
                }
              } else {
                if (nextTabNo === 4) {
                  Digit.SessionStorage.set("SUMMARYSA_TAB", true);
                  setSummaryshow(true);
                }
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setActiveTab(nextTabNo);
                Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
              }
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    } else {
      setActiveTab(nextTabNo);
      Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
    }
    // if (nextTabNo === 4) {
    //   Digit.SessionStorage.set("SUMMARY_TAB", true);
    //   setSummaryshow(true);
    // }
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading]);

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              userInfo={userInfo}
              schemeTypeData={schemeTypeData}
              nonSchemeTypeData={nonSchemeTypeData}
              id={id}
              onSelect={onSelect}
              initFormMTDocs={initFormMTDocs}
              standardDesigns={standardDesigns}
            />
          );
        case 1:
          return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 2:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 3:
          return <SubStep4 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} initFormMTDocs={initFormMTDocs} />;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return (
        <Step2 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} initFormMTDocs={initFormMTDocs} />
      );
    } else if (activeTab === 2) {
      return <Step4 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    } else if (activeTab === 3) {
      return <Step3 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 4 && summaryShow && params?.applicationNo) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary
              id={params?.applicationNo}
              ref={componentRef}
              handleDeclarationChange={handleDeclarationChange}
              declarationChecked={declarationChecked}
              showDeclaration={true}
            />
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label={params?.status === "REVERT_TO_APPLICANT" ? "Forward to Department" : "Make Payment"}
                type="submit"
                sx={{ backgroundColor: "#157CB3", width: "180px" }}
                onClick={() => handleTabChange(5, params)}
                disabled={!declarationChecked}
              />
            </div>
          </div>
        </div>
      );
    } else if (activeTab === 5) {
      return <Step6 formData={params} handleSubTabChange={handleTabChange} />;
    }
  };

  if (isAppDataLoading || (id && !applicationData)) {
    return <Loader />;
  }

  return (
    <MainWrapper>
      <BackButton />
      <FormStrip formName={t("Self-Approval via LTP Form")} />
      <PrimaryTabsWrapper className="technical-profession-section">
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          <PrimaryTab label="Drawing" />
          <PrimaryTab label="Fees" />
          <PrimaryTab label="Summary" />
          <PrimaryTab label="Application History" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default SelfApprovalPortal;
